import { render, staticRenderFns } from "./ApiDetails.vue?vue&type=template&id=6c8e1957&scoped=true&"
import script from "./ApiDetails.vue?vue&type=script&lang=js&"
export * from "./ApiDetails.vue?vue&type=script&lang=js&"
import style0 from "./ApiDetails.vue?vue&type=style&index=0&id=6c8e1957&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8e1957",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabItem } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
import { VTabsItems } from 'vuetify/lib'
installComponents(component, {
  VAlert,
  VBtn,
  VIcon,
  VLayout,
  VTab,
  VTabItem,
  VTabs,
  VTabsItems,
})
